module.exports = __webpack_public_path__ + "img/haomai.439e8ede.png";